import EditableTextField from './EditableTextField'
export default EditableTextField




// WEBPACK FOOTER //
// ./src/components/EditableTextField/index.js